import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { Paginator } from 'primeng/components/paginator/paginator';
import { DataTable } from 'primeng/components/datatable/datatable';
import { CreateOrEditCouponGroupDto, CouponsServiceProxy, UserServiceProxy, EventsServiceProxy, CouponResponsibleDto,
    CouponResponsibleSelectListDto, CreateOrEditCouponDto, AddCuponsInput } from '@shared/service-proxies/service-proxies';

import * as moment from 'moment';
import { ResponsibleType } from '@shared/AppEnums';
import { FileDownloadService } from '@shared/utils/file-download.service';

@Component({
    selector: 'createOrEditCouponGroupModal',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './create-or-edit-coupon-group-modal.component.html',
    animations: [appModuleAnimation()]
})

export class CreateOrEditCouponGroupModalComponent extends AppComponentBase implements OnInit {

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('createOrEditModal') modal: ModalDirective;
    @ViewChild('dataTableCoupon') dataTableCoupon: DataTable;
    @ViewChild('paginatorCoupon') paginatorCoupon: Paginator;

    //Filters
    filterText = '';
    filterUsed = undefined;
    filterUser = undefined;
    filterUpdatedManually = undefined;
    users = [];
    public advancedFiltersAreShown = false;

    active = false;
    saving = false;

    couponGroup: CreateOrEditCouponGroupDto = new CreateOrEditCouponGroupDto();
    coupon = new CreateOrEditCouponDto();
    events = [];
    responsibles = [];

    responsible: CouponResponsibleSelectListDto = undefined;

    quantityNewCoupons = undefined;
    expirationDateCoupon = undefined;

    constructor(
        injector: Injector,
        private _couponsService: CouponsServiceProxy,
        private _userService: UserServiceProxy,
        private _eventsService: EventsServiceProxy,
        private _fileDownloadService: FileDownloadService
    ) {
        super(injector);
    }

    onShown(): void { }

    ngOnInit(): void {
        this.initializeNewCouponGroup();
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');

        $('.datetimepicker').datetimepicker({
            locale: abp.localization.currentLanguage.name,
            format: 'L'
        });
    }

    close(): void {

        this.active = false;
        this.responsible = undefined;
        this.modal.hide();
    }

    initializeNewCouponGroup(): void {
        this.couponGroup = new CreateOrEditCouponGroupDto();
        this.couponGroup.expirationDate = moment().startOf('day');
        this.couponGroup.discountAmount = 0;
        this.couponGroup.discountPercentage = 0;
        this.couponGroup.coupons = [];

        this.coupon = new CreateOrEditCouponDto();
        this.quantityNewCoupons = undefined;
    }

    public show(couponGroupId?: number): void {

        this.initializeNewCouponGroup();
        this.active = true;

        if (couponGroupId) {

            this._couponsService.getCouponGroupForEdit(couponGroupId).subscribe(result => {

                if (result.couponGroup) {
                    this.couponGroup = result.couponGroup;

                    this.responsible = new CouponResponsibleSelectListDto();
                    this.responsible.type = +result.couponGroup.responsible.type;

                    if (result.couponGroup.responsible.type == ResponsibleType.User && result.couponGroup.responsible.user.id) {
                        this.responsible.id = result.couponGroup.responsible.user.id;
                        this.responsible.name = result.couponGroup.responsible.user.name;
                        this.responsible.type = +ResponsibleType.User;
                    }
                    else if (result.couponGroup.responsible.enterprise.id) {
                        this.responsible.id = result.couponGroup.responsible.enterprise.id;
                        this.responsible.name = result.couponGroup.responsible.enterprise.companyName;
                        this.responsible.type = +ResponsibleType.Enterprise;
                    }

                    this.modal.show();

                    setTimeout(() => {
                        this.getCoupons();
                    }, 0);
                }
            });
        }
        else {
            this.modal.show();
        }
    }

    save(): void {

        let model = new CreateOrEditCouponGroupDto();
        model.id = this.couponGroup.id;
        model.eventId = this.couponGroup.event.id;
        model.name = this.couponGroup.name;
        model.code = this.couponGroup.code;
        model.quantity = this.couponGroup.quantity;
        model.discountAmount = this.couponGroup.discountAmount;
        model.discountPercentage = this.couponGroup.discountPercentage;
        model.expirationDate = this.couponGroup.expirationDate;

        model.responsible = new CouponResponsibleDto();

        if(this.couponGroup.id) {
            model.quantity = this.couponGroup.quantity;
            model.responsible.id = this.responsible.id;
        }

        if (this.responsible.type == ResponsibleType.User) {
            model.responsible.type = +this.responsible.type;
            model.responsible.userId = this.responsible.id;
        }
        else {
            model.responsible.type = +this.responsible.type;
            model.responsible.enterpriseId = this.responsible.id;
        }

        model.coupons = this.couponGroup.coupons;
        model.coupons.forEach(x => { x.id = undefined; });

        if(!this.couponGroup.id){
            this.createOrUpdateCouponGroup(model);
        }
        else {

            let title = this.l('Warning!');
            let msg = this.l('The coupons will be saved. Do you want to apply changes to manually edited coupons?');

            this.message.confirm(
                msg,
                title,
                (isConfirmed) => {
                if (isConfirmed)
                    model.applyChangesToAll = true;
                else
                    model.applyChangesToAll = false;

                this.createOrUpdateCouponGroup(model);
                }
            );
        }
    }

    createOrUpdateCouponGroup(model: CreateOrEditCouponGroupDto): void {

        this._couponsService.createOrEditCouponGroup(model)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });

    }

    // Get Responsibles
    filterResponsibles(event): void {
        this._couponsService.getResponsiblesForSelect(
                event.query,
                undefined,
                20,
                0
            ).subscribe(result => {
            this.responsibles = result.items;
        });
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService.getEventsForSelect(event.query, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
            this.events = result.items;
        });
    }

    // Update Date on Coupon Group
    upadateExpirationDate(value: string) {
        this.couponGroup.expirationDate = value ? moment(value, 'L') : null;
    }


    // Cupons
    getCoupons(event?: LazyLoadEvent) {

        this.coupon = new CreateOrEditCouponDto();

        if(this.dataTableCoupon) {

            if (this.primengDatatableHelper.shouldResetPaging(event)) {
                this.paginatorCoupon.changePage(0);

                return;
            }

            this.primengDatatableHelper.showLoadingIndicator();

            this._couponsService.getAll(
                this.filterText,
                this.couponGroup.id,
                this.filterUser ? this.filterUser.id : undefined,
                this.filterUpdatedManually,
                this.filterUsed,
                this.primengDatatableHelper.getSorting(this.dataTableCoupon),
                this.primengDatatableHelper.getSkipCount(this.paginatorCoupon, event),
                this.primengDatatableHelper.getMaxResultCount(this.paginatorCoupon, event)
            )
            .finally(() => {
                this.primengDatatableHelper.hideLoadingIndicator();
            })
            .subscribe(result => {
                this.primengDatatableHelper.totalRecordsCount = result.totalCount;
                this.primengDatatableHelper.records = result.items;
            });
        }
    }

    reloadPage(): void {
        this.paginatorCoupon.changePage(this.paginatorCoupon.getPage());
    }

    clear(): void {
        this.filterText = '';
        this.filterUsed = undefined;
        this.filterUser = undefined;
        this.filterUpdatedManually = undefined;
      }

    addCoupons(): void {

        let input = new AddCuponsInput();
        input.id = this.couponGroup.id;
        input.quantity = this.quantityNewCoupons;

        this.saving = true;

        this._couponsService.addCouponsInGroup(input)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.getCoupons();
                this.quantityNewCoupons = undefined;
            });
    }

    editCoupon(coupon: CreateOrEditCouponDto): void {
        this.coupon = new CreateOrEditCouponDto();
        this.coupon.id = coupon.id;
        this.coupon.updatedManually = true;
        this.coupon.user = coupon.user;
        this.coupon.userId = coupon.userId;
        this.coupon.code = coupon.code;
        this.coupon.registration = coupon.registration;
        this.coupon.couponGroupId = coupon.couponGroupId;
        this.coupon.discountAmount = coupon.discountAmount;
        this.coupon.discountPercentage = coupon.discountPercentage;
        this.expirationDateCoupon = coupon.expirationDate.format("DD/MM/YYYY");
    }

    cancelEditCoupon(): void {
        this.coupon = new CreateOrEditCouponDto();
    }

    upadateEditExpirationDate() {

        let date = moment(this.expirationDateCoupon, "DD/MM/YYYY");

        if(!date.isValid())
            this.expirationDateCoupon = moment().format('L');
    }

    updateCoupon(): void {

        this.coupon.expirationDate = moment(this.expirationDateCoupon, "DD/MM/YYYY");

        this._couponsService.createOrEdit(this.coupon)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.getCoupons();
            });
    }

    deleteCoupon(coupon: any): void {
        let msg = this.l('Coupon') + ' ' + coupon.code + ' ' + this.l('will be deleted.');

        this.message.confirm(
          msg,
          (isConfirmed) => {
            if (isConfirmed) {
              this._couponsService.delete(coupon.id)
                .subscribe(() => {
                  this.reloadPage();
                  this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
          }
        );
    }

    exportToExcel(): void {
        this._couponsService.getCouponsToExcel(
            this.filterText,
            this.couponGroup.id,
            this.filterUser ? this.filterUser.id : undefined,
            this.filterUpdatedManually,
            this.filterUsed
        ).subscribe(result => {
            this._fileDownloadService.downloadTempFile(result);
        });
    }

    // Get Users
    filterUsers(event): void {
        this._userService.getUsersForSelect(
                event.query,
                undefined,
                20,
                0
            ).subscribe(result => {
            this.users = result.items;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/coupon-groups/modal/create-or-edit-coupon-group-modal.component.ts